import(/* webpackMode: "eager" */ "/var/www/vhosts/restroai.de/httpdocs/src/app/forgot-password/page.tsx");
